import DetailModal from './DetailModal.vue'

export default DetailModal
